/**
 * PDP delivery card — availability lines (Shipping / Pickup) follow the variant
 * and the warehouse stock signal.
 *
 * Lifted verbatim out of snippets/pdp-delivery-card.liquid, where it was an
 * inline <script> of about 10 KB parsed and re-downloaded on every PDP view.
 * It contains no Liquid, so it ships as a cached asset instead. Loaded with
 * `defer` from the snippet, at the same point in the document, so it still
 * runs after the card markup and #VariantInventoryJson exist and before
 * product.js and pdp.js (deferred scripts execute in document order).
 * The snippet keeps the full behavioural notes in its Liquid comment.
 */
(function () {
  if (window.__pdpDeliveryAvailability) { return; }
  window.__pdpDeliveryAvailability = true;

  var lines = document.querySelectorAll('[data-pdp-availability]');
  if (!lines.length) { return; }

  var variantsById = null;
  var inventoryJson = document.getElementById('VariantInventoryJson');
  if (inventoryJson) {
    try {
      var data = JSON.parse(inventoryJson.textContent);
      if (data && data.variants) {
        variantsById = {};
        for (var i = 0; i < data.variants.length; i++) {
          variantsById[String(data.variants[i].id)] = data.variants[i];
        }
      }
    } catch (error) { /* malformed JSON — fall back to the add button */ }
  }

  function variantAvailable() {
    var addButton = document.querySelector('.pdp_main_product__add');
    if (addButton) { return !addButton.disabled; }
    var select = document.querySelector('[data-product-select-pdp]');
    if (select && variantsById) {
      var variant = variantsById[String(select.value)];
      if (variant) { return !!variant.available; }
    }
    return true;
  }

  /* false = warehouse says out; true = orderable; null = no signal yet. */
  function shippingSignal() {
    var pill =
      document.getElementById('bopis-store--shipping-stock-status-pdp-aftership') ||
      document.querySelector('.pdp-delivery .bopis-store--shipping-stock-status');
    if (!pill) { return null; }
    return pill.classList.contains('out-of-stock') ? false : true;
  }

  /* The Aftership estimate, read from the widget's shadow root — the same
     place the deliver-to reader above gets the location from. Returns just
     the DATE, because the card supplies its own label now: the widget
     renders a full sentence from its merchant-configured template
     ("Estimated delivery: Monday, Aug 24") and echoing that whole string
     after our label would read "Estimated: Estimated delivery: Monday, Aug
     24". Everything up to and including the first colon is the widget's own
     label, so it is dropped; a template with no colon is used as-is rather
     than guessed at.

     Empty results — no widget, no shadow root (app off, or a Places
     region), or the "no location chosen yet" shape Aftership renders
     ("Estimated delivery: -") — leave the date half blank, which is
     exactly the design's pre-location state. */
  var mechanism = (function () {
    var root = document.querySelector('[data-pdp-delivery]');
    return root ? root.getAttribute('data-pdp-delivery-mechanism') : '';
  })();

  function readEta() {
    if (mechanism !== 'aftership') { return ''; }
    var host = document.getElementById('aftership-container');
    if (!host || !host.shadowRoot) { return ''; }
    var paragraph = host.shadowRoot.querySelector(
      '.as-widget-main .as-widget-template p, .as-widget-template p'
    );
    if (!paragraph) { return ''; }
    var text = (paragraph.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) { return ''; }
    /* Strip the widget's own label, but only when what precedes the colon
       really is a label: a DIGIT before it means the colon belongs to a
       time or a countdown, not to a label, and slicing there would eat the
       date itself ("Arrives by 17:00 on Monday" -> "00 on Monday", "Order
       within 02:15:33" -> "15:33"). A template with no label colon is used
       whole rather than guessed at. */
    var colon = text.indexOf(':');
    if (colon > -1 && !/\d/.test(text.slice(0, colon))) {
      text = text.slice(colon + 1).trim();
    }
    /* A lone dash (or nothing) is the widget's placeholder, not a date. */
    if (!text || /^[-–—]+$/.test(text)) { return ''; }
    return text;
  }

  function setEta(text) {
    /* Aftership only. In Places regions the date half holds a
       server-rendered `#delivery_date` span that the Places flow fills in
       place — writing textContent here would DELETE that node and the date
       would never appear again. readEta() already returns '' off
       Aftership, so without this guard every apply() pass would wipe it.

       No state class to toggle any more: the label is always shown and
       this only fills or clears the date beside it. */
    if (mechanism !== 'aftership') { return; }
    for (var l = 0; l < lines.length; l++) {
      if (lines[l].getAttribute('data-pdp-availability') !== 'shipping') { continue; }
      var slot = lines[l].querySelector('[data-pdp-availability-eta]');
      if (slot && slot.textContent !== text) { slot.textContent = text; }
    }
  }

  /* false = the selected pickup store reported out of stock; true =
     orderable; null = no verdict. header.js getStoreStockStatus() writes
     its result INTO `.bopis-store--stock-status` as child markup: a
     `div.out-of-stock` when the store has none, `div.low-stock` when low,
     and an EMPTY container when in stock — so "has an .out-of-stock child"
     is the one machine-readable out signal. The check is store-scoped and
     frozen to the page's render-time SKU (header.js never re-runs it on a
     size change — a known upstream limit), which is why the variant's own
     availability is folded in as well. A store whose service is off
     ("Unavailable for Click & Collect") is a service state, not a stock
     state, and deliberately does not turn this line red — the short-info
     text that header.js swaps in already explains it. */
  function pickupSignal() {
    var host = document.querySelector('.bopis-store--stock-status');
    if (!host) { return null; }
    return host.querySelector('.out-of-stock') ? false : true;
  }

  function setState(kind, available) {
    var oos = !available;
    for (var l = 0; l < lines.length; l++) {
      if (lines[l].getAttribute('data-pdp-availability') !== kind) { continue; }
      /* In-store-only is a server-rendered, tag-driven state; no runtime
         signal may overwrite it. */
      if (lines[l].classList.contains('is-instore')) { continue; }
      /* Line and row are checked INDEPENDENTLY, each write guarded on its
         own current value. An earlier version skipped the whole body when
         the line's class already matched — which meant a product that
         ships sold-out (is-oos server-rendered on the line) never received
         the row-level class, and the delivery details stayed visible under
         the red text. The row class is now also server-rendered for that
         case; these guarded writes keep both in step at runtime without
         feeding the MutationObserver no-op churn. */
      if (lines[l].classList.contains('is-oos') !== oos) {
        lines[l].classList.toggle('is-oos', oos);
      }
      var row = lines[l].closest('.pdp-delivery__row');
      if (row && row.classList.contains('pdp-delivery__row--oos') !== oos) {
        row.classList.toggle('pdp-delivery__row--oos', oos);
      }
    }
  }

  var frame = null;
  function apply() {
    frame = null;
    var vAvail = variantAvailable();
    setState('shipping', vAvail && shippingSignal() !== false);
    setState('pickup', vAvail && pickupSignal() !== false);
    /* After setState so the oos check inside sees the fresh class. */
    setEta(readEta());
  }

  function schedule() {
    if (frame !== null) { return; }
    frame = typeof window.requestAnimationFrame === 'function'
      ? window.requestAnimationFrame(apply)
      : setTimeout(apply, 16);
  }

  /* Three signal shapes, one coalesced observer: product.js toggles the
     add button's `disabled` ATTRIBUTE, header.js swaps the shipping pill's
     CLASSES, and header.js writes the pickup verdict as CHILD MARKUP
     (innerHTML) into .bopis-store--stock-status — hence childList as well
     as attributes. The size-change path in header.js runs 100ms after the
     change event plus network time, and an observer (unlike a change
     listener) catches those late writes whenever they land. */
  if (typeof window.MutationObserver === 'function') {
    var observer = new MutationObserver(schedule);
    var scopes = [
      document.querySelector('.pdp-product-form-section') || document.body,
      document.querySelector('[data-pdp-delivery]')
    ];
    for (var s = 0; s < scopes.length; s++) {
      if (scopes[s]) {
        observer.observe(scopes[s], {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'disabled']
        });
      }
    }
  }
  document.addEventListener('change', schedule);

  /* The estimate lives inside Aftership's SHADOW root, which the subtree
     observer above cannot see — shadow trees are separate observation
     targets. Same attach-with-retry pattern the deliver-to reader uses:
     the widget mounts asynchronously, so poll for the shadow root, then
     observe it directly. Bounded retries: if the app never mounts (app
     disabled, consent withheld, ZA), this stops quietly and the line
     stays on "Available". */
  if (typeof window.MutationObserver === 'function' && mechanism === 'aftership') {
    (function attachEtaWatch(tries) {
      var host = document.getElementById('aftership-container');
      if (host && host.shadowRoot) {
        new MutationObserver(schedule).observe(host.shadowRoot, {
          childList: true,
          subtree: true,
          characterData: true
        });
        schedule();
        return;
      }
      if (tries > 0) { setTimeout(function () { attachEtaWatch(tries - 1); }, 500); }
    })(40);
  }

  apply();
})();
